import { fusoHorarioDoNavegador } from "@/utils/exportarConversaPdf";

const ZONAS_BRASIL = [
  "America/Sao_Paulo", "America/Manaus", "America/Rio_Branco", "America/Cuiaba",
  "America/Belem", "America/Fortaleza", "America/Recife", "America/Bahia",
  "America/Noronha", "UTC",
];

/**
 * Fusos oferecidos nos seletores de exportação; o do navegador é sempre incluído e
 * pré-selecionado. `opcoes` mapeia fuso → rótulo com o offset atual.
 */
export function fusosDisponiveis(): { opcoes: Record<string, string>; padrao: string } {
  const zonas = [...ZONAS_BRASIL];
  const doNavegador = fusoHorarioDoNavegador();
  if (!zonas.includes(doNavegador)) zonas.unshift(doNavegador);
  const rotulo = (tz: string) => {
    try {
      const partes = new Intl.DateTimeFormat("pt-BR", { timeZone: tz, timeZoneName: "shortOffset" }).formatToParts(new Date());
      const offset = partes.find((p) => p.type === "timeZoneName")?.value ?? "";
      return offset ? `${tz} (${offset})` : tz;
    } catch {
      return tz;
    }
  };
  return { opcoes: Object.fromEntries(zonas.map((tz) => [tz, rotulo(tz)])), padrao: doNavegador };
}
